import DateFormatService from '../DateFormatService';
import { UkgDateFormat } from '../../Enums/UkgDateFormat';

/* eslint-disable import/prefer-default-export */
export const getScheduledTime = (schedule, hasScheduledDateAndTime) => {
    if (!hasScheduledDateAndTime) {
        return '';
    }

    if (schedule.isAddedWhenClosed) {
        return 'Appended';
    }

    return DateFormatService.formatPeriod(
        schedule.employeeSubmissionStartDate,
        schedule.employeeSubmissionEndDate,
        UkgDateFormat.ShortDateTime,
    );
};
